import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {showCustomToast,CustomToastContainer} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/auth";
import { Link, useNavigate } from 'react-router-dom';

const User_renew = () => {
  const { id } = useParams();
  const [licenseData, setLicenseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState({});
  const [showDocument, setShowDocument] = useState(null);
  const StatusEnum = ["In-Progress", "Submitted", "Rejected", "Completed"];
  const navigate = useNavigate(); // Use navigate to redirect
const [documents, setDocuments] = useState(null)


  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const response = await axios.get(
          `https://api.makeeasydocuments.com/api/renewalLicense/getRenewalDL/${id}`
        );
        const data = response.data;
        console.log("Fetched Data: ", data);
        setLicenseData({
          fullName: data.fullName || "",
          state: data.state || "",
          rto: data.rto || "",
          permanentLicenseNumber: data.permanentLicenseNumber || "",
          licenseData: data.licenseData || "",
          fatherOrHusbandFullName: data.fatherOrHusbandFullName || "",
          gender: data.gender || "",
          dateOfBirth: data.dateOfBirth || "",
          qualification: data.qualification || "",
          identificationMarks: data.identificationMarks || "",
          bloodGroup: data.bloodGroup || "",
          emergencyContact: data.emergencyContact || "",
          email: data.email || "",
          address: data.address || "",
          district: data.district || "",
          taluka: data.taluka || "",
          rejectedNote: data.rejectedNote || "",
          createdAt: data.createdAt || "",
          updatedAt: data.updatedAt || "",
          Status: data.Status || "",
          documents: data.documents || {}, 
          statusHistory:data.statusHistory||"",
        })
      } catch (err) {
        setError("Error fetching license data", 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, [id]);

  const handleUpdate = async (event) => {
    event.preventDefault();


    // Update the Status to "In-Progress"
    const updatedLicenseData = { ...licenseData, Status: "In-Progress" };
    const formData = new FormData();


    for (const key in updatedLicenseData) {
      if (updatedLicenseData.hasOwnProperty(key)) {
        // Skip the documents and user objects
        if (key !== 'documents' && key !== 'user') {
          // Handle dates specially
          if (updatedLicenseData[key] instanceof Date) {
            formData.append(key, updatedLicenseData[key].toISOString());
          }
          // Handle primitive values
          else if (typeof updatedLicenseData[key] !== 'object') {
            formData.append(key, updatedLicenseData[key]);
          }
        }
      }
    }
    // Append license data to formData
    // for (const key in updatedLicenseData) {
    //   formData.append(key, updatedLicenseData[key]);
    // }
    
    //   // Append all fields from licenseData to formData
    //   for (const key in licenseData) {
    //     formData.append(`fields.${key}`, licenseData[key]); // Prefix with 'fields.'
    //   }
  
    //   // Append files to formData with prefix 'documents.'
    //   for (const key in documents) {
    //     if (documents[key]) {
    //       formData.append(`documents.${key}`, documents[key]);
    //     }
    //   }

    if (updatedLicenseData.user && updatedLicenseData.user._id) {
      formData.append('user', updatedLicenseData.user._id);
    }

    console.log("User Data:", licenseData.user);
    console.log("Updated Status:", updatedLicenseData.Status);

      // Append files to formData
      for (const [key, value] of Object.entries(files)) {
        if (value instanceof File) {
            formData.append(`documents.${key}`, value);
        }
    }

    // Log the FormData content for debugging
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
  }


    try {
      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/renewalLicense/updaterenewallicense/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      showCustomToast(response.data.message);
      setTimeout(() => {
        navigate("/dashboard/my_application");
    }, 4001);
    } catch (error) {
      console.log("data", formData)
      console.log("error", error)
      //   showCustomToast("Failed to update license.", 'error');
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLicenseData({ ...licenseData, [name]: value });
  };
  const handleFileChange = (event) => {
    const { name, files } = event.target;
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: files[0],
    }));
  };

  const renderImage = (imageData) => {
    try {
      // Check if all required properties exist and are valid
      if (
        imageData && 
        imageData.contentType && 
        imageData.data && 
        imageData.data.data && 
        Array.isArray(imageData.data.data)
      ) {
        const byteArray = new Uint8Array(imageData.data.data);
        const base64String = btoa(
          Array.from(byteArray)
            .map(byte => String.fromCharCode(byte))
            .join('')
        );
        return `data:${imageData.contentType};base64,${base64String}`;
      }
      console.log("Invalid image data:", imageData);
      return null;
    } catch (error) {
      console.error("Error rendering image:", error);
      return null;
    }
  };

  const DocumentPreviewModal = ({ document, onClose }) => {
    if (!document) return null;
  
    // Check if document is a string (URL) or an object
    const documentUrl = typeof document === 'string' ? document : null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
          <h2>Download The Documents From Here...</h2>
          
          {documentUrl && (
            <div className="my-4">
              <img 
                src={documentUrl} 
                className="max-w-full max-h-96 mx-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ""; // Placeholder for failed image load
                  // e.target.alt = "Unable to preview document";
                }}
              />
            </div>
          )}
  
          <div className="mt-4 flex justify-between">
            <button
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
              onClick={onClose}
            >
              Close
            </button>
            {documentUrl && (
              
                <a href={documentUrl}
                download
                className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
              >
                Download
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };

  const DownloadableDocuments = () => {
    console.log("License Data Documents:", licenseData.documents); // Debug log
    if (!licenseData.documents) return null; // Ensure documents is defined

    const { receipt, finisheddoc } = licenseData.documents;

    const status = licenseData.Status;

    return (
      <div className="col-span-3 bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Downloadable Documents
        </h2>
        {(status === "Submitted" || status === "Completed") && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {(status === "Submitted" || status === "Completed") ? (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Receipt</h3>
              <button
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                  onClick={() => {
                    const imageUrl = renderImage(receipt);
                    setShowDocument(imageUrl);
                  }}
                >
                  View Receipt
                </button>
            </div>
          ) : (
            <div className="hidden sm:block"></div> // Placeholder to maintain layout
          )}
          {status === "Completed" && finisheddoc ? (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Finished Document</h3>
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                onClick={() => setShowDocument(renderImage(finisheddoc))}
              >
                View Document
              </button>
            </div>
          ) : (
            <div className="hidden sm:block"></div> // Placeholder to maintain layout
          )}
        </div>
      )}
      </div>
    );
  };

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-500">{error}</div>;
  if (!licenseData) return <div>No data found</div>;

  const labelClass = "block text-sm mb-2 font-medium text-gray-700";
  const inputClass = "border border-gray-300 rounded-md p-2 w-full";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          <div className="px-4 py-5 sm:p-6">
            <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
              Renew Driving License
            </h1>
            <DownloadableDocuments />

            <form onSubmit={handleUpdate} className="space-y-6">
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                {/* Personal Information Section */}
                <div className="col-span-3">
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                    <div>
                      <label htmlFor="fullName" className={labelClass}>
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="fullName"
                        className={inputClass}
                        value={licenseData.fullName}
                        onChange={handleInputChange}
                        
                        placeholder="Enter Full Name"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      /></div>
                    <div>
                      <label htmlFor="state" className={labelClass}>
                        State
                      </label>
                      <input
                        type="text"
                        id="state"
                        className={inputClass}
                        value={licenseData.state}
                        onChange={handleInputChange}
                        placeholder="Enter State"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>
                    <div>
                      <label htmlFor="rto" className={labelClass}>
                        Rto
                      </label>
                      <input
                        type="text"
                        id="rto"
                        className={inputClass}
                        value={licenseData.rto}
                        onChange={handleInputChange}
                        placeholder="Enter Rto"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="permanentLicenseNumber"
                        className={labelClass}
                      >
                        Permanent License Number
                      </label>
                      <input
                        type="text"
                        id="permanentLicenseNumber"
                        className={inputClass}
                        value={licenseData.permanentLicenseNumber}
                        onChange={handleInputChange}
                        placeholder="Enter full Permanent License Number"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>
                    <div>
                      <label htmlFor="vehicleType" className={labelClass}>
                        Vehicle Type
                      </label>
                      <select
                        id="vehicleType"
                        className={inputClass}
                        value={licenseData.vehicleType}
                        onChange={handleInputChange}
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      >
                        <option value="" disabled>
                          Select Vehicle Type
                        </option>
                        <option value="motorcycle">Motor Cycle</option>
                        <option value="twowheeler">Two Wheeler</option>
                        <option value="fourwheeler">Four Wheeler</option>
                        <option value="fourwheelerTR">Four Wheeler TR</option>
                        <option value="fourPlusTwo">Four + Two Wheeler</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="fatherOrHusbandFullName" className={labelClass}>
                        Father Name
                      </label>
                      <input
                        type="text"
                        id="fatherOrHusbandFullName"
                        className={inputClass}
                        value={licenseData.fatherOrHusbandFullName}
                        onChange={handleInputChange}
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="gender" className={labelClass}>
                        Gender
                      </label>
                      <select
                        id="gender"
                        className={inputClass}
                        value={licenseData.gender}
                        onChange={handleInputChange}
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div>
                      <label className={labelClass} htmlFor="dateOfBirth">
                        Date of Birth
                      </label>
                      <input
                        id="dateOfBirth"
                        name="dateOfBirth"
                        type="date"
                        className={`${inputClass} border border-gray-300 rounded-md`}
                        value={licenseData.dateOfBirth}
                        onChange={handleInputChange}
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                      />
                    </div>
                    <div>
                      <label htmlFor="qualification" className={labelClass}>
                        Qualification
                      </label>
                      <input
                        type="text"
                        id="qualification"
                        className={inputClass}
                        value={licenseData.qualification}
                        onChange={handleInputChange}
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>


                    <div>
                      <label htmlFor="bloodGroup" className={labelClass}>
                        Blood Group
                      </label>
                      <input
                        type="text"
                        id="bloodGroup"
                        className={inputClass}
                        value={licenseData.bloodGroup}
                        onChange={handleInputChange}
                        placeholder="Enter blood Group"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="emergencyNumber" className={labelClass}>
                        Emergency Number
                      </label>
                      <input
                        type="text"
                        id="emergencyNumber"
                        className={inputClass}
                        value={licenseData.birthState}
                        onChange={handleInputChange}
                        placeholder="Enter Emergency Number"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className={labelClass}>
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        className={inputClass}
                        value={licenseData.email}
                        onChange={handleInputChange}
                        placeholder="Enter email"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                  <label htmlFor="address" className={labelClass}>
                    Address
                  </label>
                  <input
                    type="text"
                    id="address"
                    className={inputClass}
                    value={licenseData.address || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        address: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                    <div>
                      <label htmlFor="district" className={labelClass}>
                        district
                      </label>
                      <input
                        type="text"
                        id="district"
                        className={inputClass}
                        value={licenseData.district}
                        onChange={handleInputChange}
                        placeholder="Enter district"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="taluka" className={labelClass}>
                        taluka
                      </label>
                      <input
                        type="text"
                        id="taluka"
                        className={inputClass}
                        value={licenseData.taluka}
                        onChange={handleInputChange}
                        placeholder="Enter taluka "
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>
                  </div>
                </div>


                {/* Document Upload Section */}
                <div className="col-span-3">
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                    {["aadhaarCard", "voterID", "addressProof", "photo"].map(
                      (doc) => (
                        <div key={doc}>
                          <label htmlFor={doc} className={labelClass}>
                            {doc.replace(/([A-Z])/g, " $1").toUpperCase()}
                          </label>
                          <input
                            type="file"
                            id={doc}
                            className={inputClass}
                            onChange={handleFileChange}

                            accept=".jpg,.jpeg,.png,.pdf"
                          />
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Status Section */}
                {/* Application History */}
                <div className="col-span-3 bg-green-50 shadow-md p-6 rounded-lg w-full lg:w-full space-y-4">
                  <h2 className="text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
                    Application History
                  </h2>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Created At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {new Date(licenseData.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </div>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Updated At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.updatedAt
                        ? new Date(licenseData.updatedAt).toLocaleString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          }
                        )
                        : "N/A"}
                    </span>
                  </div>

                  <div>
                    <label htmlFor="Status" className={labelClass}>
                      Status{" "}
                    </label>
                    <input
                      disabled
                      type="text"
                      id="Status"
                      className={inputClass}
                      value={licenseData.Status}
                      onChange={(e) =>
                        setLicenseData({
                          ...licenseData,
                          Status: e.target.value,
                        })
                      }
                      placeholder="Status"
                      required
                    />
                  </div>

             {/* history */}
                {/* Display history regardless of Status */}
                <div className="flex justify-between text-gray-800">
                  <div className="text-gray-600 flex-1">
                    <strong className="text-gray-600">Status History:</strong>
                  </div>

                  {/* Display for new schema with statusHistory */}
                  {licenseData.statusHistory && licenseData.statusHistory.length > 0 ? (
                    <div className="flex-1 text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.statusHistory.map((statusChange, index) => (
                        <div
                          key={index}
                          className={`p-3 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b border-gray-300 last:border-b-0`}
                        >
                          <div className="flex justify-between items-center mb-1">
                            <span className="text-sm font-medium text-gray-500">
                              Changed on: {new Date(statusChange.changedAt).toLocaleString()}
                            </span>
                            <span className={`text-xs font-semibold px-2 py-1 rounded ${statusChange.status === 'Rejected' ? 'bg-red-100 text-red-800' :
                                statusChange.status === 'Submitted' ? 'bg-blue-100 text-blue-800' :
                                  statusChange.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                    'bg-yellow-100 text-yellow-800'
                              }`}>
                              {statusChange.status}
                            </span>
                          </div>
                          <p className="text-gray-700">{statusChange.note || "No additional notes"}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    // Fallback for when no status history exists
                    <div className="text-center text-gray-500 border border-gray-300 bg-gray-50 p-3 rounded">
                      No status history available
                    </div>
                  )}
                </div>            
            </div>
               
              </div>

              {licenseData.Status === "Rejected" && (
              <div>
                <button
                  type="submit"
                  className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                >
                 Update Application
                </button>
              </div>
            )}

            </form>

            <DocumentPreviewModal
              document={showDocument}
              onClose={() => setShowDocument(null)}
            />

            <CustomToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default User_renew;
